import { PublicRoutes } from "@/constants/routes";
import type { LegalDocumentKey } from "./types";

export const SITE_URL = "https://fidexa.com.br";

/** Dados institucionais — os mesmos do contrato de licenciamento. */
export const COMPANY = {
  legalName: "FIDEXA SERVIÇOS DE CRÉDITO LTDA",
  cnpj: "63.161.339/0001-90",
  address: "Rua Guararapes, 136, Vila Claudia, Limeira/SP, CEP 13480-405",
} as const;

/**
 * Encarregado pelo tratamento de dados pessoais (LGPD, art. 41; Resolução
 * CD/ANPD nº 18/2024). Nome e contato têm de ficar públicos e atualizados.
 */
export const DPO = {
  name: "Leonardo Azevedo",
  email: "leonardo.azevedo@fidexa.com.br",
} as const;

/**
 * Ouvidoria: sócio que não atua na operação, para que a reclamação seja
 * avaliada por quem não participou do caso.
 */
export const OMBUDSMAN = {
  name: "André Menezes",
  role: "Sócio advisor",
  email: "andre.menezes@fidexa.com.br",
} as const;

/**
 * Canais públicos de contato. O comercial é o mesmo número das LPs e do
 * DemoFormModal; o suporte é o da "Central de Ajuda" do rodapé.
 */
export const CHANNELS = {
  commercialWhatsapp: "5519936195831",
  supportWhatsapp: "5519936196753",
  pressEmail: "imprensa@fidexa.com.br",
} as const;

/**
 * Prazos do ciclo de vida da conta. Aparecem em quatro documentos
 * (Cancelamento, Retenção, Privacidade, LGPD): mude aqui, e todos mudam juntos.
 */
export const ACCOUNT_TERMS = {
  /** Teste grátis, sem pagamento. */
  trialDays: 7,
  /** Depois do fim do acesso: plataforma só para leitura e cópia por e-mail. */
  readOnlyDays: 30,
  /** Guarda bloqueada, contada do fim do acesso; depois, eliminação. */
  retentionDays: 365,
} as const;

/** Navegação entre os documentos — a ordem aqui é a ordem na tela. */
export const LEGAL_NAV: {
  key: LegalDocumentKey;
  label: string;
  path: string;
}[] = [
  {
    key: "privacidade",
    label: "Política de Privacidade",
    path: PublicRoutes.POLITICA_PRIVACIDADE,
  },
  { key: "lgpd", label: "LGPD", path: PublicRoutes.LGPD },
  {
    key: "retencao",
    label: "Retenção de dados",
    path: PublicRoutes.RETENCAO_DADOS,
  },
  { key: "seguranca", label: "Segurança", path: PublicRoutes.SEGURANCA },
  {
    key: "disponibilidade",
    label: "Disponibilidade",
    path: PublicRoutes.DISPONIBILIDADE,
  },
  {
    key: "cancelamento",
    label: "Política de Cancelamento",
    path: PublicRoutes.POLITICA_CANCELAMENTO,
  },
  { key: "ouvidoria", label: "Ouvidoria", path: PublicRoutes.OUVIDORIA },
  { key: "termos", label: "Termos de Uso", path: PublicRoutes.TERMOS_DE_USO },
];
